export const managerData = [391, 370, 285, 400, 375];

export const nationalAverageData = [401, 360, 290, 355];

export const managerQuarterData = [500, 390, 670, 600];

export const nationalAverageQuarterData = [600, 400, 600, 550];

//---Labels---//

export const yearLabels = ["January", "February", "March", "April"];

export const quarterLabels = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];

//---Labels---//

//---More Complex Dataset---//

export const districtManagerData = [
  { sum: 13100, newarkBranch: 4500, austinBranch: 3700, denverBranch: 4900 },
  { sum: 12500, newarkBranch: 3900, austinBranch: 3700, denverBranch: 4900 },
  { sum: 12050, newarkBranch: 3450, austinBranch: 3700, denverBranch: 4900 },
  { sum: 13200, newarkBranch: 4600, austinBranch: 3700, denverBranch: 4900 },
  { sum: 13035, newarkBranch: 4435, austinBranch: 3700, denverBranch: 4900 },
  { sum: 12700, newarkBranch: 4100, austinBranch: 3700, denverBranch: 4900 },
  { sum: 13720, newarkBranch: 5120, austinBranch: 3700, denverBranch: 4900 },
  { sum: 13550, newarkBranch: 4700, austinBranch: 3950, denverBranch: 4900 },
  { sum: 12700, newarkBranch: 4100, austinBranch: 3700, denverBranch: 4900 },
  { sum: 12800, newarkBranch: 4200, austinBranch: 3700, denverBranch: 4900 },
  { sum: 11800, newarkBranch: 3950, austinBranch: 3650, denverBranch: 4200 },
  { sum: 12745, newarkBranch: 3620, austinBranch: 3780, denverBranch: 5345 },
];
